<section id="index-contact-section">
    <div class="container">
        <div class="contact-header text-white">
            <div class="contact-pill">
                <span class="dot"></span>
                <span>Connect with Powell Industries</span>
            </div>
            <h2>Choose the channel that works best for your team.</h2>
            <p class="text-primary">Our specialists are on standby across every timezone.</p>
        </div>

        <div class="row g-4 mt-3">
            <div class="col-md-4">
                <div class="contact-card">
                    <div class="icon-circle">
                        <fa-icon [icon]="faPhone"></fa-icon>
                    </div>
                    <h4>Phone</h4>
                    <p>Instant access to the PI command desk for live triage, project updates, or roadmap discussions.</p>
                    <a href="tel:+14049646847" class="btn btn-outline-light w-100">+1 (404) 964-6847</a>
                    <span class="availability">24/7 availability</span>
                </div>
            </div>
            <div class="col-md-4">
                <div class="contact-card contact-card-highlighted">
                    <div class="icon-circle">
                        <fa-icon [icon]="faEnvelope"></fa-icon>
                    </div>
                    <h4>Email</h4>
                    <p>Send detailed briefs, attachments, or approvals and receive a tailored response within two hours.</p>
                    <a href="mailto:support@powellii.com" class="btn btn-primary w-100">support@powellii.com</a>
                    <span class="availability">Priority queue</span>
                </div>
            </div>
            <div class="col-md-4">
                <div class="contact-card">
                    <div class="icon-circle">
                        <fa-icon [icon]="faComments"></fa-icon>
                    </div>
                    <h4>Chat</h4>
                    <p>Get rapid answers in the PI Portal with co-browsing, screen shares, and product walkthroughs.</p>
                    <button class="btn btn-outline-light w-100 disabled">Temporarily Unavailable</button>
                    <span class="availability">Weekdays 8AM – 10PM EST</span>
                </div>
            </div>
        </div>
    </div>
</section>
